import ProgressBar from '@ramonak/react-progress-bar';
import React from 'react';
import pause from '../../../../assets/pause.svg';
import { parceBudget, parcePercentage } from '../../../../helpers/parceBudget';
import css from '../Tables.module.css';
import { formater } from './functions';

export const ClientsBudget = ({
  type,
  el,
  isDefaultCurrentCycleView,
  isTotalRow,
  handleCheckOne,
  handleClickClient,
}) => {
  return (
    <tr
      className={`${css.tr} ${isTotalRow ? css.trTotal : ''}`}
      key={formater('key', el, type)}
    >
      <td className={css.tdA}>
        {!isTotalRow && (
          <input
            className={css.checkbox}
            type="checkbox"
            checked={el.isChecked}
            onChange={handleCheckOne.bind(this, formater('key', el, type))}
          />
        )}
      </td>

      <td
        className={css.td}
        style={
          isTotalRow
            ? { color: '#111A39', cursor: 'not-allowed' }
            : { color: '#1649EC', cursor: 'pointer' }
        }
        onClick={handleClickClient}
      >
        {isTotalRow ? 'Total' : el.client_name}
      </td>

      <td className={css.td}>{parceBudget(el.budget_amount, el.currency)}</td>

      <td className={css.td}>
        {isDefaultCurrentCycleView ? (
          <div className={css.progressBarContainer}>
            <ProgressBar
              completed={+el.spend}
              maxCompleted={+el.budget_amount}
              customLabel={parceBudget(el.spend, el.currency, 0)}
              borderRadius="0"
              height="3rem"
              bgColor={formater('primaryColor', +el.trend, type)}
              baseBgColor={formater('secondaryColor', +el.trend, type)}
              labelAlignment="left"
              labelColor="var(--white)"
              labelSize="1.2rem"
              labelClassName={css.progressBarLabel}
              width="13rem"
            />
            {el?.status === 'paused' && (
              <img className={css.pause} alt="pause" src={pause} />
            )}
          </div>
        ) : (
          <>{parceBudget(el.spend, el.currency, 0)}</>
        )}
      </td>

      <td
        className={`${css.td} ${formater(
          'trendColor',
          el.trend,
          el?.completed_status ?? '',
        )}`}
      >
        {formater('trendName', el.trend, el?.completed_status ?? '')}
      </td>

      <td className={css.td}>
        {parceBudget(el.remaining_budget, el.currency)}
      </td>

      <td className={css.td}>
        {parceBudget(el.ideal_daily_spend, el.currency)}
      </td>

      <td className={css.td}>{parceBudget(el.yesterday_spend, el.currency)}</td>

      <td className={css.td}>
        {parceBudget(el.tree_days_avg_spend, el.currency)}
      </td>

      <td className={css.td}>{parceBudget(el.forecast_spend, el.currency)}</td>

      <td className={css.td}>
        {parcePercentage(el.lost_is_budget_percentage)}
      </td>
    </tr>
  );
};
